import React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import Layout from "../../components/layout-en"
import ImageDeroulement from "../../components/imageDeroulement-en"
import ImageConsultation from "../../components/imageConsultation-en"
import ImageVivalto from "../../components/imageVivalto"
import ImageTeleconsultation from "../../components/imageTeleconsultation"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import SEO from "../../components/seo-en"
import Share from "../../components/share-en"
import { MdPhone, MdLocationOn } from "react-icons/md"
import { FaLink } from "react-icons/fa"

const ConsultationPage = () => (
  <Layout pathFr="/consultation/">
    <SEO
      title="Hand, elbow and shoulder surgery consultation"
      description="Consultations take place at the Espace Médical Vauban in
      Paris. This clinic is used by doctors specialising in the
      treatment of pathologies linked to sport."
    />
    <Helmet>
      <link
        rel="alternate"
        hreflang="fr"
        href={`https://www.docteurphilipperoure.com/consultation/`}
      />
    </Helmet>
    <ImageConsultation />
    <WrapperTitle>
      <Breadcrumb>
        <Link to="/en/">Home </Link>
      </Breadcrumb>
      <H1>Hand, elbow and shoulder surgery consultation</H1>
      <p className="intro">
        Consultations take place mainly at the Espace Médical Vauban. Located in
        Paris (7<sup>th</sup> arrondissement), opposite the Dôme des Invalides,
        this clinic is used by doctors and surgeons specialising in the
        treatment of pathologies linked to sport and osteoarthritis.
      </p>
    </WrapperTitle>

    <Wrapper>
      <Row>
        <Col1>
          <H2>
            Consultation <span>procedure</span>
          </H2>
          <p>
            During the consultation, I undertake an expert examination of your
            hand or upper limb medical problem, possibly using{" "}
            <strong>additional techniques</strong> (x-ray, CAT scan, MRI, etc.)
            and together we will determine your{" "}
            <strong>personal objectives</strong> and requirements.
          </p>
          <p>
            We will then consider the different treatment options, and for each
            one I will explain the advantages, disadvantages and potential
            risks. Next we choose the{" "}
            <strong>solution best suited to your case</strong> and your
            expectations.
          </p>
          <p>
            You will also be given a detailed quotation for the{" "}
            <strong>cost of the procedure</strong> to pass on to your health
            insurance body or insurance company, for full or partial cover
            depending on your policy.
          </p>
          <p>
            You will, of course, have the option of calling me back or returning
            for additional consultations for further explanations. After your
            procedure, I will also see you again for consultations until you are
            <strong>fully recovered</strong> or your condition has stabilised.
          </p>
        </Col1>
        <Col2>
          <ImageDeroulement />
        </Col2>
      </Row>

      <Row>
        <Col3>
          <iframe
            width="100%"
            height="350"
            src="https://www.youtube.com/embed/TRNa8Ovs4Vk?rel=0"
            allowfullscreen="allowfullscreen"
            frameborder="0"
            title="Video of Espace Médical Vauban in Paris"
            css={css`
              @media (max-width: 678px) {
                height: 190px;
              }
            `}
          />
        </Col3>

        <Col4>
          <H2>
            The <span>Espace Médical Vauban</span> in Paris
          </H2>
          <p>
            Created in 2006, the{" "}
            <strong>
              <a
                href="http://www.vauban-medical.com/"
                target="_blank"
                rel="noreferrer noopener"
              >
                Espace M&eacute;dical Vauban
              </a>
            </strong>{" "}
            is a consultation centre dedicated to Sports Medicine and Surgery
            and osteoarthritis treatment.
          </p>
          <p>
            The practitioners who make up the medical and surgical team are{" "}
            <strong>specialists in the musculoskeletal system</strong>, and have
            long been recognised for their involvement in the treatment of
            high-performance athletes.
          </p>
          <p>
            The centre is located at the corner of Place Vauban and Avenue de
            Ségur, opposite the <strong>Dôme des Invalides</strong>, and is
            easily accessible by public transport. Parking is also available in
            the surrounding streets.
          </p>

          <p>
            <Link to="/en/contact/">> See access map</Link>
          </p>
        </Col4>
      </Row>

      <H2>
        <span>CHP</span> Montgardé
      </H2>
      <ImageVivalto />
      <p>
        I am also a member of the{" "}
        <strong>Val de Seine Emergency Hand Department</strong> at{" "}
        <a
          href="https://chp-montgarde.fr/"
          target="blank"
          rel="noreferrer noopener"
        >
          CHP Montgard&eacute;
        </a>{" "}
        (Vivalto Santé) in Yvelines. This unit specialises in upper limb
        surgery, dealing in particular with{" "}
        <Link to="/en/hand-surgery/hand-emergency/">hand emergencies</Link>, and
        is approved by the European Federation of Emergency Hand Services (
        <a
          href="https://www.fesum.fr/"
          target="blank"
          rel="noreferrer noopener"
        >
          FESUM
        </a>
        ). Hand emergencies are dealt with <strong>24&nbsp;hours a day</strong>{" "}
        by an emergency doctor and surgery is undertaken by one of the team's
        surgeons, specialising in hand surgery and microsurgery.
      </p>
      <p>
        I provide consultations and perform surgical procedures there on{" "}
        <strong>Wednesdays</strong> and some <strong>Mondays</strong>, and the
        operating theatre allows me to perform all upper limb procedures,
        including shoulder and elbow procedures.
      </p>
      <p>
        My <strong>assistants</strong> Christelle, Julie, Sabah and Sylvie and
        our nurse Manon will be there to welcome you and provide you with
        information, including when I am not present on site. My{" "}
        <strong>colleagues</strong>, Doctors Abadie, Barbato, Beauthier,
        Ghafanzari and Werther, can treat you in the event of an urgent problem
        in my absence.
        <br />
        &nbsp;
      </p>
      <Row>
        <Col1>
          <H2>
            <span>Online</span> medical consultation
          </H2>
          <p>
            Doctor Philippe Roure offers an online consultation service with the{" "}
            <strong>Doctolib platform</strong>. This service provides easy
            access to the expertise of Dr. Philippe Roure, for a first
            diagnostic consultation or a follow-up consultation, wherever you
            are.
          </p>
          <p>
            Before your remote consultation, you can send Dr Roure your{" "}
            <strong>additional exam results</strong> using the Doctolib system.{" "}
            <strong>Prescriptions</strong> can also be sent to you after the
            consultation.
          </p>
          <p>
            Depending on your problem, a complementary{" "}
            <strong>face-to-face consultation</strong> may however be necessary
            in a second step.
          </p>
          <p>
            The <strong>practical details</strong> of the online consultation
            will be detailed to you by clicking on the "Video" tab in the
            Doctolib appointment booking section.
          </p>
          <p>
            <a
              href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
              rel="noreferrer noopener"
            >
              > Book an apointment
            </a>
          </p>
        </Col1>
        <Col2>
          <ImageTeleconsultation />
        </Col2>
      </Row>
      <Row
        css={css`
          margin-top: 55px;
        `}
      >
        <Col5>
          <h3
            css={css`
              opacity: 0.8;
              font-size: 1.45em;
            `}
          >
            Address
          </h3>
          <p
            css={css`
              font-size: 0.93em;
              line-height: 1.85em;
            `}
          >
            UMVS - CHP Montgard&eacute;
            <br />
            <MdLocationOn /> 32, rue du Montgard&eacute; - 78410 Aubergenville
            <br />
            <MdPhone
              css={css`
                font-size: 1.1em;
                margin-top: 3px;
              `}
            />{" "}
            01 30 95 12 20
            <br />
            <a
              href="https://chp-montgarde.fr/"
              target="blank"
              rel="noreferrer noopener"
              css={css`
                border-bottom: none;
              `}
            >
              <FaLink
                css={css`
                  font-size: 0.84em;
                `}
              />{" "}
              Website
            </a>
          </p>
        </Col5>
        <Col6>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10479.476425222223!2d1.8467521!3d48.9559782!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6fcc38e98c90d90!2sCentre+Hospitalier+Priv%C3%A9+du+Montgard%C3%A9!5e0!3m2!1sfr!2sus!4v1558378957413!5m2!1sfr!2sus"
            width="100%"
            height="225"
            title="Map of Dr Philippe Roure practice in Paris"
            frameborder="0"
            allowfullscreen
          />
        </Col6>
      </Row>
      <Share
        slug="https://www.docteurphilipperoure.com/en/consultation/"
        title="Hand, elbow and shoulder surgery consultation
        - Dr Roure"
      />
    </Wrapper>
  </Layout>
)

export default ConsultationPage

const WrapperTitle = styled.div`
  background-color: white;
  width: 78%;
  margin: 0 auto;
  border-radius: 7px;
  padding: 1.5em 2em 0.9em;
  margin-bottom: 45px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1024px) {
    width: 100%;
    box-sizing: border-box;
    padding: 1em 1em 0.5em;
    margin-bottom: 25px;
    border-radius: 0 0 7px 7px;
  }
`
const Breadcrumb = styled.div`
  color: #e6ae48;
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  font-size: 2.1em;
  @media (max-width: 678px) {
    font-size: 1.82em;
    line-height: 1.1em;
  }
`

const Wrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 0.5em;
  padding: 2.25em 2em 1em 2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 678px) {
    border-radius: 7px;
    padding: 1em;
  }
`

const H2 = styled.h2`
  font-weight: 400;
  line-height: 1.38em;
  font-size: 1.9em;
  margin-block-start: 0;
  span {
    font-weight: 800;
  }
  @media (max-width: 678px) {
    font-size: 1.7em;
    line-height: 1.3em;
  }
`

const Row = styled.div`
  display: flex;
  margin: 15px 0 55px;
  clear: both;
  @media (max-width: 678px) {
    flex-wrap: wrap;
    margin: 0px 0 30px;
  }
`

const Col1 = styled.div`
  flex: 69%;
  padding-right: 10px;
  @media (max-width: 678px) {
    padding-right: 0;
    flex-basis: 100%;
  }
`

const Col2 = styled.div`
  flex: 31%;
  padding-left: 10px;
  @media (max-width: 678px) {
    padding: 0;
    flex-basis: 100%;
  }
`

const Col3 = styled.div`
  flex: 50%;
  padding-right: 10px;
  @media (max-width: 678px) {
    order: 2;
    flex-basis: 100%;
  }
`

const Col4 = styled.div`
  flex: 50%;
  padding-left: 10px;
  @media (max-width: 678px) {
    order: 1;
    flex-basis: 100%;
    padding: 0;
  }
`

const Col5 = styled.div`
  flex: 30%;
  @media (max-width: 678px) {
    order: 2;
    flex-basis: 100%;
  }
`

const Col6 = styled.div`
  flex: 70%;
  @media (max-width: 678px) {
    order: 1;
    flex-basis: 100%;
  }
`
